import { render, staticRenderFns } from "./TradeRefferences.vue?vue&type=template&id=4c139c46"
import script from "./TradeRefferences.vue?vue&type=script&lang=js"
export * from "./TradeRefferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports